import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  TextInput, required, NumberInput,
} from "react-admin";
import EditView from "../../../components/EditView";
import CreateView from "../../../components/CreateView";
import ShowView from "../../../components/ShowView";

export const OrderTypeList = (props) => (

  <List {...props}>
    <Datagrid rowClick="edit"  sort={{ field: 'order', order: 'ASC' }}>
      {/* <DateField  locales={"fa-IR"} source="createdAt" /> */}
      <TextField source="title" />
      <TextField source="order" />

    </Datagrid>
  </List>
);

export const OrderTypeEdit = (props) => (
  <EditView {...props} perPage={10}>
    <TextInput source="order" validate={required()} />
    <TextInput source="title" validate={required()} />
  </EditView>
);

export const OrderTypeShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField source="order" />
      <DateField locales={"fa-IR"} source="createdAt" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" />
    </SimpleShowLayout>
  </ShowView>
);

export const OrderTypeCreate = (props) => (
  <CreateView {...props}>
    <NumberInput source="order" label="ترتیب" required />
    <TextInput source="title" label="عنوان" />
  </CreateView>
);
